<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.warehousecheck_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/warehouse/warehousecheck";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 350,
                    tip: false,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    column: [
                                                                                    {
                                    label: "主键",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "项目id",
                                    prop: "projectId",
                                    rules: [{
                                        required: true,
                                        message: "请输入项目id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "仓库id",
                                    prop: "warehouseId",
                                    rules: [{
                                        required: true,
                                        message: "请输入仓库id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点计划id",
                                    prop: "planId",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点计划id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点任务名称",
                                    prop: "name",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点任务名称",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点单批次号",
                                    prop: "code",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点单批次号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点任务类型，系统字典warehouse_check_task_type，1-临时/2-周期",
                                    prop: "type",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点任务类型，系统字典warehouse_check_task_type，1-临时/2-周期",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "申请人id",
                                    prop: "applyUserId",
                                    rules: [{
                                        required: true,
                                        message: "请输入申请人id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "申请人姓名",
                                    prop: "applyUserName",
                                    rules: [{
                                        required: true,
                                        message: "请输入申请人姓名",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点有效时间起",
                                    prop: "validTimeStart",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点有效时间起",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点有效时间止",
                                    prop: "validTimeEnd",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点有效时间止",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点开始时间",
                                    prop: "checkStartTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点开始时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点完成时间",
                                    prop: "checkEndTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点完成时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "审核人id",
                                    prop: "approveUserId",
                                    rules: [{
                                        required: true,
                                        message: "请输入审核人id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "审核时间",
                                    prop: "approveTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入审核时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点单执行状态，系统字典warehouse_check_task_work_status，1-待审核/2-审核不通过/3-待盘点/4-盘点中/5-盘点关闭",
                                    prop: "workStatus",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点单执行状态，系统字典warehouse_check_task_work_status，1-待审核/2-审核不通过/3-待盘点/4-盘点中/5-盘点关闭",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点单执行结果，系统字典warehouse_check_result，-1-亏/0-平/1-盈",
                                    prop: "checkResult",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点单执行结果，系统字典warehouse_check_result，-1-亏/0-平/1-盈",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点盈亏金额",
                                    prop: "resultAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点盈亏金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "盘点结果提交标志位，0-未提交/1-已提交",
                                    prop: "resultSubmitFlag",
                                    rules: [{
                                        required: true,
                                        message: "请输入盘点结果提交标志位，0-未提交/1-已提交",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "description",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "remark",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "版本",
                                    prop: "version",
                                    rules: [{
                                        required: true,
                                        message: "请输入版本",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehousecheck_add, false),
                    viewBtn: this.vaildData(this.permission.warehousecheck_view, false),
                    delBtn: this.vaildData(this.permission.warehousecheck_delete, false),
                    editBtn: this.vaildData(this.permission.warehousecheck_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style scoped>
  ::v-deep .avue-form__menu--center{
    text-align: right;
  }
  ::v-deep .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
  
</style>
<style >
#warehouseconsumable .el-table .cell{
    white-space: inherit;
  }
</style>
